<script setup lang="ts">
import { computed, ref } from '#imports';
import FormUserSignIn from './form-user-sign-in.vue';
import FormUserSignUp from './form-user-sign-up.vue';

const props = withDefaults(defineProps<{
	modelValue: boolean;
}>(), {
	modelValue: false,
});

const emit = defineEmits<{
	(e: 'update:modelValue'): void;
}>();

const value = computed({
	get: () => props.modelValue,
	set: () => emit('update:modelValue'),
});

const tabs = ref([
	{ title: 'войти', content: FormUserSignIn },
	{ title: 'создать аккаунт', content: FormUserSignUp },
]);

const selectedTab = ref(tabs.value[0].title);
</script>

<template>
	<v-dialog v-model="value">
		<div class="dialog-user-sign">
			<h2 class="dialog-user-sign__title mb-24">
				Войдите или создайте аккаунт
			</h2>

			<v-tabs v-model="selectedTab" :tabs="tabs" />
		</div>
	</v-dialog>
</template>
